import { ContactDto } from './contact.dto';
import { FinancialDto } from './financial.dto';
import { GeneralDetailsDto } from './general-details.dto';
import { PrsDto } from './prs.dto';

export class AccountRegistrationDto {
  eLicensingEmailAddress: string;
  generalDetails: GeneralDetailsDto;
  prs: PrsDto;
  financial: FinancialDto;
  contacts: Array<ContactDto>;
  licenseTypes: Array<string>;
  organisationType: string;
  registrationNumber: string;
  exTradeName: string;

  constructor(
    eLicensingEmailAddress: string,
    generalDetails: GeneralDetailsDto,
    prs: PrsDto,
    financial: FinancialDto,
    contacts: Array<ContactDto>,
    licenseTypes: Array<string>,
    organisationType: string,
    registrationNumber: string,
    exTradeName: string
  ) {
    this.eLicensingEmailAddress = eLicensingEmailAddress;
    this.generalDetails = generalDetails;
    this.prs = prs;
    this.financial = financial;
    this.contacts = contacts;
    this.organisationType = organisationType;
    this.registrationNumber = registrationNumber;
    this.exTradeName = exTradeName;
    this.licenseTypes = licenseTypes;
  }

  getContactByEmail(email: string): ContactDto {
    if (email) {
      email = email.toLocaleLowerCase();
      for (let contact of this.contacts) {
        if (contact.email.toLocaleLowerCase() === email) {
          return contact;
        }
      }
    }
    return null;
  }
}
